import * as actionTypes from "../actionTypes";

export const getReferencesList = (data) => {
    return {
        type: actionTypes.GET_REFERENCES_LIST_START,
        payload: data,
    };
};
export const getReferencesListSuccess = (data) => {
    return {
        type: actionTypes.GET_REFERENCES_LIST_SUCCESS,
        payload: data,
    };
};
export const getReferencesListFailure = (data) => {
    return {
        type: actionTypes.GET_REFERENCES_LIST_FAILURE,
        payload: data,
    };
};

export const getUserData = (data) => {
    return {
        type: actionTypes.GET_USER_DATA_START,
        payload: data,
    };
};
export const getUserDataSuccess = (data) => {
    return {
        type: actionTypes.GET_USER_DATA_SUCCESS,
        payload: data,
    };
};
export const getUserDataFailure = (data) => {
    return {
        type: actionTypes.GET_USER_DATA_FAILURE,
        payload: data,
    };
};

export const addNewReferenceStart = (data) => {
    return {
        type: actionTypes.ADD_NEW_REFERENCE_START,
        payload: data,
    };
};
export const  addNewReferenceSuccess = (data) => {
    return {
        type: actionTypes.ADD_NEW_REFERENCE_SUCCESS,
        payload: data,
    };
};
export const  addNewReferenceFailure = (data) => {
    return {
        type: actionTypes.ADD_NEW_REFERENCE_FAILURE,
        payload: data,
    };
};
export const  editReference = (data) => {
    return {
        type: actionTypes.EDIT_REFERENCE,
        payload: data,
    };
};

export const updateUser = (data) => {
    return {
        type: actionTypes.UPDATE_USER_START,
        payload: data,
    };
};
export const  updateReferenceSuccess = (data) => {
    return {
        type: actionTypes.UPDATE_USER_SUCCESS,
        payload: data,
    };
};
export const  updateUserFailure = (data) => {
    return {
        type: actionTypes.UPDATE_USER_FAILURE,
        payload: data,
    };
};

export const  deleteReferenceSuccess = (data) => {
    return {
        type: actionTypes.DELETE_USER_SUCCESS,
        payload: data,
    };
};
export const  deleteUserFailure = (data) => {
    return {
        type: actionTypes.DELETE_USER_FAILURE,
        payload: data,
    };
};

export const  referenceMessageHandler = () => {
    return {
        type: actionTypes.REFERENCE_MESSAGE_HANDLER,
        payload: null,
    };
};
